/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {AudioInputChannel} from "../model/audio-input-channel";
import {PhoneAudioInputChannel} from "../model/phone-audio-input-channel";
import {AudioOutputChannel} from "../model/audio-output-channel";
import {AudioChannelGroup} from "../model/audio-channel-group";
import {NetworkAudioInputChannel} from "../model/network-audio-input-channel";
import {BlackboxExporter} from "../model/blackbox-exporter";
import {Camera} from "../model/camera";
import {EnergySchedule} from "../model/energy-schedule";
import {GrafanaReportConfiguration} from "../model/grafana-report-configuration";
import {Iconset} from "../model/iconset";
import {Icon} from "../model/icon";
import {FileSet} from "../model/file-set";
import {Markerset} from "../model/markerset";
import {Mediaset} from "../model/mediaset";
import {Media} from "../model/media";
import {Scenario} from "../model/scenario";
import {ScenarioGroup} from "../model/scenario-group";
import {Scheduler} from "../model/scheduler";
import {SynchEndpoint} from "../model/synch-endpoint";
import {Exstreamer} from "../model/exstreamer";
import {PlayerMapping} from "../model/player-mapping";
import {TabletMapping} from "../model/tablet-mapping";
import {ViewingStationMapping} from "../model/viewing-station-mapping";
import {TrainingRoomPcMapping} from "../model/training-room-pc-mapping";
import {MasterOfCeremonyMapping} from "../model/master-of-ceremony-mapping";
import {RecorderMapping} from "../model/recorder-mapping";
import {LdapConfiguration} from "../model/ldap-configuration";
import {LdapRoleMapping} from "../model/ldap-role-mapping";
import {Setting} from "../model/setting";
import {SimRole} from "../model/sim-role";
import {Tracker} from "../model/tracker";
import {TrainingRoom} from "../model/training-room";
import {TrainingRoomGroup} from "../model/training-room-group";
import {VOGSet} from "../model/vog-set";
import {VTPSet} from "../model/vtp-set";
import {WebPage} from "../model/web-page";
import {TeamTrainingSession} from "../model/team-training-session";
import {ExamFlow} from "../model/exam-flow";
import {RatingItemIconSet} from "../model/rating-item-icon-set";
import {Device} from "../model/device";
import {DeviceState} from "../model/device-state";
import {SynchronizationJobInfo} from "../model/synchronization-job-info";
import {ScenarioRecording} from "../model/scenario-recording";
import {SimUser} from "../model/sim-user";
import {ConnectedWebClient} from "../model/connected-web-client";
import {Event} from "../model/event";
import {UserRecordingChecklist} from "../model/user-recording-checklist";
import {UserRecordingAssessment} from "../model/user-recording-assessment";
import {PowerDistributionUnit} from "../model/power-distribution-unit";
import {TrainingRoomGroupView} from "../model/training-room-group-view";
import {TraceRecord} from "../model/trace-record";
import {SimGroup} from "../model/sim-group";
import {OccupiedTrainingRoom} from "../model/occupied-training-room";
import {PeerPracticeStation} from "../model/peer-practice-station";
import {AutomaticRecordingSession} from "../model/automatic-recording-session";
import {IpDevice} from "../model/ip-device";
import {UserCalendarFeedAccessToken} from "../model/user-calendar-feed-access-token";
import {SchedulerEventLogEntry} from "../model/scheduler-event-log-entry";
import {ControlPanel} from "../model/control-panel";
import {ScenarioGroupView} from "../model/scenario-group-view";
import {AudioVideoDownloadJobInfo} from "../model/audio-video-download-job-info";
import {DynamicInputGroupPreset} from "../model/dynamic-input-group-preset";
import {WebCameraView} from "../model/web-camera-view";
import {OutlookClientConfig} from "../model/outlook-client-config";
import {Assessment} from "../model/assessment";
import {SwitchCastVideoProcessingJobInfo} from "../model/switch-cast-video-processing-job-info";
import {AutomaticRecordingFlowState} from "../model/automatic-recording-flow-state";
import {PeerPracticeSession} from "../model/peer-practice-session";
import {ExamFlowState} from "../model/exam-flow-state";
import {PeerPracticeFlowState} from "../model/peer-practice-flow-state";
import {SchedulerView} from "../model/scheduler-view";
import {Tag} from "../model/tag";
import {OperatorChecklist} from "../model/operator-checklist";
import {ExamSession} from "../model/exam-session";
import {MultiRoomRecordingStation} from "../model/multi-room-recording-station";
import {AutomaticRecordingStation} from "../model/automatic-recording-station";
import {WebClientConnection} from "../model/web-client-connection";
import {DeleteTemporaryFileJobInfo} from "../model/delete-temporary-file-job-info";
import {MultiRoomRecordingFlowState} from "../model/multi-room-recording-flow-state";
import {EventAttachment} from "../model/event-attachment";
import {ExamStation} from "../model/exam-station";
import {Checklist} from "../model/checklist";
import {CompetenceCategory} from "../model/competence-category";
import {NonSimulationSession} from "../model/non-simulation-session";
import {Acl} from "../model/acl";
import {SwitchCastVideoUploadJobInfo} from "../model/switch-cast-video-upload-job-info";
import {MultiRoomRecordingSession} from "../model/multi-room-recording-session";
import {ExportProcessInfo} from "../model/export-process-info";
import {Favorite} from "../model/favorite";
import {DashboardTileMap} from "../model/dashboard-tile-map";
import {DisplayAutoLoginCapability} from "../model/display-auto-login-capability";
import {ExaminerPcAutoLoginCapability} from "../model/examiner-pc-auto-login-capability";
import {ExamStudentReadyPcAutoLoginCapability} from "../model/exam-student-ready-pc-auto-login-capability";
import {NoneAutoLoginCapability} from "../model/none-auto-login-capability";
import {StandardizedPatientPcAutoLoginCapability} from "../model/standardized-patient-pc-auto-login-capability";
import {ApplicationData} from "../model/application-data";
import {ErrorApplicationData} from "../model/error-application-data";
import {BasePeerPracticeRunApplicationData} from "../model/base-peer-practice-run-application-data";
import {PeerPracticeClosingApplicationData} from "../model/peer-practice-closing-application-data";
import {PeerPracticeConfirmationApplicationData} from "../model/peer-practice-confirmation-application-data";
import {PeerPracticeEncounterApplicationData} from "../model/peer-practice-encounter-application-data";
import {PeerPracticeIntermissionApplicationData} from "../model/peer-practice-intermission-application-data";
import {PeerPracticeUpcomingSessionApplicationData} from "../model/peer-practice-upcoming-session-application-data";
import {BaseMultiRoomRecordingRunApplicationData} from "../model/base-multi-room-recording-run-application-data";
import {MultiRoomRecordingClosingApplicationData} from "../model/multi-room-recording-closing-application-data";
import {MultiRoomRecordingEncounterApplicationData} from "../model/multi-room-recording-encounter-application-data";
import {MultiRoomRecordingFinishedApplicationData} from "../model/multi-room-recording-finished-application-data";
import {MultiRoomRecordingIntermissionApplicationData} from "../model/multi-room-recording-intermission-application-data";
import {MultiRoomRecordingUpcomingSessionApplicationData} from "../model/multi-room-recording-upcoming-session-application-data";
import {ExamApplicationData} from "../model/exam-application-data";
import {ExamClosingApplicationData} from "../model/exam-closing-application-data";
import {ExamIdleApplicationData} from "../model/exam-idle-application-data";
import {ExamRunEncounterApplicationData} from "../model/exam-run-encounter-application-data";
import {ExamRunPostEncounterApplicationData} from "../model/exam-run-post-encounter-application-data";
import {ExamRunPreEncounterApplicationData} from "../model/exam-run-pre-encounter-application-data";
import {ExamRunStudentReadyApplicationData} from "../model/exam-run-student-ready-application-data";
import {ExamMasterOfCeremonyApplicationData} from "../model/exam-master-of-ceremony-application-data";
import {ExamMasterOfCeremonyRunApplicationData} from "../model/exam-master-of-ceremony-run-application-data";
import {ExamMcClosingApplicationData} from "../model/exam-mc-closing-application-data";
import {ExamMcConfirmationClosedApplicationData} from "../model/exam-mc-confirmation-closed-application-data";
import {ExamMcConfirmationRunningApplicationData} from "../model/exam-mc-confirmation-running-application-data";
import {ExamMcEncounterApplicationData} from "../model/exam-mc-encounter-application-data";
import {ExamMcIdleApplicationData} from "../model/exam-mc-idle-application-data";
import {ExamMcPostEncounterApplicationData} from "../model/exam-mc-post-encounter-application-data";
import {ExamMcPreEncounterApplicationData} from "../model/exam-mc-pre-encounter-application-data";
import {ExamMcStudentReadyApplicationData} from "../model/exam-mc-student-ready-application-data";
import {ExamConfirmationApplicationData} from "../model/exam-confirmation-application-data";
import {ExamConfirmationClosedApplicationData} from "../model/exam-confirmation-closed-application-data";
import {ExamConfirmationRunningApplicationData} from "../model/exam-confirmation-running-application-data";
import {RoomStateScreenApplicationData} from "../model/room-state-screen-application-data";
import {UnusedScreenDisplayApplicationData} from "../model/unused-screen-display-application-data";
import {SimUserUnrestricted} from "../model/sim-user-unrestricted";
import {WebClientAudioChannelConfiguration} from "../model/web-client-audio-channel-configuration";
import {NetworkAudioOutputChannel} from "../model/network-audio-output-channel";
import {FileSetConversionJobInfo} from "../model/file-set-conversion-job-info";
import {DataAcl} from "../model/data-acl";
import {SwitchCastConfiguration} from "../model/switch-cast-configuration";
import {OpenIdConnectConfig} from "../model/open-id-connect-config";
import {LmsToken} from "../model/lms-token";
import {DefaultCameraResolutions} from "../model/default-camera-resolutions";
import {ConversionFileMetaInfo} from "../model/conversion-file-meta-info";
import {ExamStationView} from "../model/exam-station-view";
import {AutoLoginCapability} from "../model/auto-login-capability";
import {IApplicationData} from "../model/i-application-data";
import {TrainingSession} from "../model/training-session";
import {SimSession} from "../model/sim-session";
import {Assessable} from "../model/assessable";
import {MappingBase} from "../model/mapping-base";
import {DBObject} from "../model/db-object";
import {WebAudioClientMapping} from "../model/web-audio-client-mapping";
import {SessionFlowState} from "../model/session-flow-state";
import {AudioChannel} from "../model/audio-channel";
import {BaseJobInfo} from "../model/base-job-info";
import {DBConfig} from "../model/db-config";
import {BasePeerPracticeApplicationData} from "../model/base-peer-practice-application-data";
import {ExamRunApplicationData} from "../model/exam-run-application-data";
import {BaseMultiRoomRecordingApplicationData} from "../model/base-multi-room-recording-application-data";
import {IDBObject} from "../model/idb-object";
import {IHasPermissions} from "../model/i-has-permissions";
import {IOwned} from "../model/i-owned";
import {IId} from "../model/i-id";
import {IDeletable} from "../model/i-deletable";
import {IDBOBjectTime} from "../model/idbo-bject-time";
import {ITypePredicate} from "../model/i-type-predicate";
import {IUserNameable} from "../model/i-user-nameable";
import {AudioDeviceInputChannelType} from "../model/audio-device-input-channel-type";
import {AudioDeviceIconType} from "../model/audio-device-icon-type";
import {AudioDeviceOutputChannelType} from "../model/audio-device-output-channel-type";
import {AudioNetworkProtocolType} from "../model/audio-network-protocol-type";
import {BlackboxExporterModule} from "../model/blackbox-exporter-module";
import {ILatency} from "../model/i-latency";
import {VideoSourceFormat} from "../model/video-source-format";
import {VideoDestinationFormat} from "../model/video-destination-format";
import {DeviceType} from "../model/device-type";
import {ConnectivityState} from "../model/connectivity-state";
import {CameraProxyStatus} from "../model/camera-proxy-status";
import {CameraConfiguration} from "../model/camera-configuration";
import {DeviceInformation} from "../model/device-information";
import {DailyEnergySchedule} from "../model/daily-energy-schedule";
import {GrafanaReportType} from "../model/grafana-report-type";
import {VideoFileMetaData} from "../model/video-file-meta-data";
import {VideoFileMapping} from "../model/video-file-mapping";
import {AudioFileMapping} from "../model/audio-file-mapping";
import {StreamingSetStateInfo} from "../model/streaming-set-state-info";
import {INamed} from "../model/i-named";
import {IMetaData} from "../model/i-meta-data";
import {MediaType} from "../model/media-type";
import {ITaggable} from "../model/i-taggable";
import {ScenarioAssessments} from "../model/scenario-assessments";
import {ScenarioSettings} from "../model/scenario-settings";
import {ScenarioDevelopment} from "../model/scenario-development";
import {PatientInformation} from "../model/patient-information";
import {ExtraPatientInformation} from "../model/extra-patient-information";
import {TechnicalReqRoomVision} from "../model/technical-req-room-vision";
import {Actor} from "../model/actor";
import {ExamAssessmentWrapper} from "../model/exam-assessment-wrapper";
import {IntervalUnit} from "../model/interval-unit";
import {IMappingBase} from "../model/i-mapping-base";
import {IMappingIdentifier} from "../model/i-mapping-identifier";
import {IDeviceIdentifier} from "../model/i-device-identifier";
import {IWakeOnLan} from "../model/i-wake-on-lan";
import {IMappingInfoBase} from "../model/i-mapping-info-base";
import {PlayerInfo} from "../model/player-info";
import {DisplayMode} from "../model/display-mode";
import {PlayerType} from "../model/player-type";
import {SignageConfiguration} from "../model/signage-configuration";
import {TabletInfo} from "../model/tablet-info";
import {ITrainingRoomWhitelist} from "../model/i-training-room-whitelist";
import {ViewingStationInfo} from "../model/viewing-station-info";
import {TrainingRoomEntranceInfo} from "../model/training-room-entrance-info";
import {WebRecorderInfo} from "../model/web-recorder-info";
import {RecorderViewMode} from "../model/recorder-view-mode";
import {VogMode} from "../model/vog-mode";
import {DynamicAssignedAudioChannelGroup} from "../model/dynamic-assigned-audio-channel-group";
import {LdapSecurityConfiguration} from "../model/ldap-security-configuration";
import {LdapAuthType} from "../model/ldap-auth-type";
import {LdapNodeType} from "../model/ldap-node-type";
import {SettingType} from "../model/setting-type";
import {SettingCategory} from "../model/setting-category";
import {TrainingRoomType} from "../model/training-room-type";
import {CameraLayout} from "../model/camera-layout";
import {RoomCapability} from "../model/room-capability";
import {DeviceActivityType} from "../model/device-activity-type";
import {Permissions} from "../model/permissions";
import {ISimSession} from "../model/i-sim-session";
import {IParticipated} from "../model/i-participated";
import {IParseableInterface} from "../model/i-parseable-interface";
import {SessionType} from "../model/session-type";
import {ExamPhase} from "../model/exam-phase";
import {ExamFlowParticipantDevice} from "../model/exam-flow-participant-device";
import {IconConfig} from "../model/icon-config";
import {DeviceNetworkSettings} from "../model/device-network-settings";
import {IDeviceCapability} from "../model/i-device-capability";
import {WebSocketConnection} from "../model/web-socket-connection";
import {IDeviceActivity} from "../model/i-device-activity";
import {IHasScenarioRecordingId} from "../model/i-has-scenario-recording-id";
import {IPostProcessingCount} from "../model/i-post-processing-count";
import {IPostProcessingProgress} from "../model/i-post-processing-progress";
import {Participant} from "../model/participant";
import {Marker} from "../model/marker";
import {RecordingScene} from "../model/recording-scene";
import {ScenarioRecordingState} from "../model/scenario-recording-state";
import {ScenarioRecordingMessage} from "../model/scenario-recording-message";
import {SwitchCastData} from "../model/switch-cast-data";
import {MediaEvent} from "../model/media-event";
import {IGroupable} from "../model/i-groupable";
import {ISimUser} from "../model/i-sim-user";
import {Gender} from "../model/gender";
import {UserType} from "../model/user-type";
import {LoginType} from "../model/login-type";
import {EventState} from "../model/event-state";
import {EventColors} from "../model/event-colors";
import {EventType} from "../model/event-type";
import {WebClientType} from "../model/web-client-type";
import {AssessmentState} from "../model/assessment-state";
import {TraceRecordSeverity} from "../model/trace-record-severity";
import {SimGroupType} from "../model/sim-group-type";
import {GroupColor} from "../model/group-color";
import {OccupationState} from "../model/occupation-state";
import {IUseSessionFlowState} from "../model/i-use-session-flow-state";
import {AutomaticRecordingRunState} from "../model/automatic-recording-run-state";
import {AutomaticRecordingScheduleEntry} from "../model/automatic-recording-schedule-entry";
import {SchedulerEventLogType} from "../model/scheduler-event-log-type";
import {ControlPanelLocation} from "../model/control-panel-location";
import {ControlPanelType} from "../model/control-panel-type";
import {Position} from "../model/position";
import {Size} from "../model/size";
import {OutlookUser} from "../model/outlook-user";
import {AssessmentItem} from "../model/assessment-item";
import {PeerPracticeRunState} from "../model/peer-practice-run-state";
import {PeerPracticeScheduleEntry} from "../model/peer-practice-schedule-entry";
import {ExamRunState} from "../model/exam-run-state";
import {SupportRequest} from "../model/support-request";
import {SchedulerState} from "../model/scheduler-state";
import {TagType} from "../model/tag-type";
import {SessionPhaseConfirmation} from "../model/session-phase-confirmation";
import {SessionPhaseClosing} from "../model/session-phase-closing";
import {ExamScheduleEntry} from "../model/exam-schedule-entry";
import {ExamScheduleSettings} from "../model/exam-schedule-settings";
import {MultiRoomRecordingRunState} from "../model/multi-room-recording-run-state";
import {ChecklistItem} from "../model/checklist-item";
import {MultiRoomRecordingAudioAnnouncement} from "../model/multi-room-recording-audio-announcement";
import {IHasLog} from "../model/i-has-log";
import {ExportConfig} from "../model/export-config";
import {ExportState} from "../model/export-state";
import {ExportVisualState} from "../model/export-visual-state";
import {ExportJobInfo} from "../model/export-job-info";
import {EntityType} from "../model/entity-type";
import {Scope} from "../model/scope";
import {ClientApplication} from "../model/client-application";
import {DisplayDeviceType} from "../model/display-device-type";
import {IError} from "../model/i-error";
import {PeerPracticeUserSubGroupRunDto} from "../model/peer-practice-user-sub-group-run-dto";
import {MultiRoomRecordingStationDto} from "../model/multi-room-recording-station-dto";
import {ExamApplicationDataType} from "../model/exam-application-data-type";
import {ExamStationDto} from "../model/exam-station-dto";
import {SessionPhaseType} from "../model/session-phase-type";
import {ConfirmationParticipantDto} from "../model/confirmation-participant-dto";
import {RoomObservationState} from "../model/room-observation-state";
import {ConversionJobInfo} from "../model/conversion-job-info";
import {DataRoles} from "../model/data-roles";
import {DataPermissions} from "../model/data-permissions";
import {IOpenIdConnectConfig} from "../model/i-open-id-connect-config";
import {UserMappingType} from "../model/user-mapping-type";
import {CameraResolution} from "../model/camera-resolution";
import {ConversionFileType} from "../model/conversion-file-type";
import {TrainingSessionUserData} from "../model/training-session-user-data";
import {TrainingSessionClientData} from "../model/training-session-client-data";
import {ScenarioRecordingGroup} from "../model/scenario-recording-group";
import {SessionState} from "../model/session-state";
import {SessionLogEntry} from "../model/session-log-entry";
import {ExternalCalendarReference} from "../model/external-calendar-reference";
import {AssessableItemGroup} from "../model/assessable-item-group";
import {AssessableItem} from "../model/assessable-item";
import {DataPermissionType} from "../model/data-permission-type";
import {SessionRunState} from "../model/session-run-state";
import {SessionRunParticipantStateType} from "../model/session-run-participant-state-type";
import {AudioMediaDto} from "../model/audio-media-dto";

export class GeneratedTypePredicates {
  static isAudioInputChannel(value: any): value is AudioInputChannel {
    return value?.objectType === "SimStation.BO.Audio.AudioInputChannel";
  }
  static isPhoneAudioInputChannel(value: any): value is PhoneAudioInputChannel {
    return value?.objectType === "SimStation.BO.PhoneAudioInputChannel";
  }
  static isAudioOutputChannel(value: any): value is AudioOutputChannel {
    return value?.objectType === "SimStation.BO.AudioOutputChannel";
  }
  static isAudioChannelGroup(value: any): value is AudioChannelGroup {
    return value?.objectType === "SimStation.BO.AudioChannelGroup";
  }
  static isNetworkAudioInputChannel(value: any): value is NetworkAudioInputChannel {
    return value?.objectType === "SimStation.BO.Audio.NetworkAudioInputChannel";
  }
  static isBlackboxExporter(value: any): value is BlackboxExporter {
    return value?.objectType === "SimStation.BO.Reports.BlackboxExporter";
  }
  static isCamera(value: any): value is Camera {
    return value?.objectType === "SimStation.BO.Camera";
  }
  static isEnergySchedule(value: any): value is EnergySchedule {
    return value?.objectType === "SimStation.BO.EnergySchedule";
  }
  static isGrafanaReportConfiguration(value: any): value is GrafanaReportConfiguration {
    return value?.objectType === "SimStation.BO.Reports.GrafanaReportConfiguration";
  }
  static isIconset(value: any): value is Iconset {
    return value?.objectType === "SimStation.BO.Iconset";
  }
  static isIcon(value: any): value is Icon {
    return value?.objectType === "SimStation.BO.Icon";
  }
  static isFileSet(value: any): value is FileSet {
    return value?.objectType === "SimStation.BO.InternalStreaming.FileSet";
  }
  static isMarkerset(value: any): value is Markerset {
    return value?.objectType === "SimStation.BO.Markerset";
  }
  static isMediaset(value: any): value is Mediaset {
    return value?.objectType === "SimStation.BO.Mediaset";
  }
  static isMedia(value: any): value is Media {
    return value?.objectType === "SimStation.BO.Media";
  }
  static isScenario(value: any): value is Scenario {
    return value?.objectType === "SimStation.BO.Scenario";
  }
  static isScenarioGroup(value: any): value is ScenarioGroup {
    return value?.objectType === "SimStation.BO.ScenarioGroup";
  }
  static isScheduler(value: any): value is Scheduler {
    return value?.objectType === "SimStation.BO.Scheduler";
  }
  static isSynchEndpoint(value: any): value is SynchEndpoint {
    return value?.objectType === "SimStation.BO.SynchEndpoint";
  }
  static isExstreamer(value: any): value is Exstreamer {
    return value?.objectType === "SimStation.BO.Exstreamer";
  }
  static isPlayerMapping(value: any): value is PlayerMapping {
    return value?.objectType === "SimStation.BO.Mappings.PlayerMapping";
  }
  static isTabletMapping(value: any): value is TabletMapping {
    return value?.objectType === "SimStation.BO.Mappings.TabletMapping";
  }
  static isViewingStationMapping(value: any): value is ViewingStationMapping {
    return value?.objectType === "SimStation.BO.Mappings.ViewingStationMapping";
  }
  static isTrainingRoomPcMapping(value: any): value is TrainingRoomPcMapping {
    return value?.objectType === "SimStation.BO.Mappings.TrainingRoomPcMapping";
  }
  static isMasterOfCeremonyMapping(value: any): value is MasterOfCeremonyMapping {
    return value?.objectType === "SimStation.BO.Mappings.MasterOfCeremonyMapping";
  }
  static isRecorderMapping(value: any): value is RecorderMapping {
    return value?.objectType === "SimStation.BO.Mappings.RecorderMapping";
  }
  static isLdapConfiguration(value: any): value is LdapConfiguration {
    return value?.objectType === "SimStation.BO.LdapIntegration.LdapConfiguration";
  }
  static isLdapRoleMapping(value: any): value is LdapRoleMapping {
    return value?.objectType === "SimStation.BO.Users.LdapRoleMapping";
  }
  static isSetting(value: any): value is Setting {
    return value?.objectType === "SimStation.BO.Configuration.Setting";
  }
  static isSimRole(value: any): value is SimRole {
    return value?.objectType === "SimStation.BO.Users.SimRole";
  }
  static isTracker(value: any): value is Tracker {
    return value?.objectType === "SimStation.BO.Tracker";
  }
  static isTrainingRoom(value: any): value is TrainingRoom {
    return value?.objectType === "SimStation.BO.TrainingRoom";
  }
  static isTrainingRoomGroup(value: any): value is TrainingRoomGroup {
    return value?.objectType === "SimStation.BO.TrainingRoomGroup";
  }
  static isVOGSet(value: any): value is VOGSet {
    return value?.objectType === "SimStation.BO.VOGSet";
  }
  static isVTPSet(value: any): value is VTPSet {
    return value?.objectType === "SimStation.BO.VTPSet";
  }
  static isWebPage(value: any): value is WebPage {
    return value?.objectType === "SimStation.BO.WebPage";
  }
  static isTeamTrainingSession(value: any): value is TeamTrainingSession {
    return value?.objectType === "SimStation.BO.Session.TeamTraining.TeamTrainingSession";
  }
  static isExamFlow(value: any): value is ExamFlow {
    return value?.objectType === "SimStation.BO.Session.Exam.ExamFlow";
  }
  static isRatingItemIconSet(value: any): value is RatingItemIconSet {
    return value?.objectType === "SimStation.BO.RatingItemIconSet";
  }
  static isDevice(value: any): value is Device {
    return value?.objectType === "SimStation.BO.Device.Device";
  }
  static isDeviceState(value: any): value is DeviceState {
    return value?.objectType === "SimStation.BO.Device.DeviceState";
  }
  static isSynchronizationJobInfo(value: any): value is SynchronizationJobInfo {
    return value?.objectType === "SimStation.BO.Jobs.SynchronizationJobInfo";
  }
  static isScenarioRecording(value: any): value is ScenarioRecording {
    return value?.objectType === "SimStation.BO.ScenarioRecording";
  }
  static isSimUser(value: any): value is SimUser {
    return value?.objectType === "SimStation.BO.Users.SimUser";
  }
  static isConnectedWebClient(value: any): value is ConnectedWebClient {
    return value?.objectType === "SimStation.BO.ConnectedWebClient";
  }
  static isEvent(value: any): value is Event {
    return value?.objectType === "SimStation.BO.Event";
  }
  static isUserRecordingChecklist(value: any): value is UserRecordingChecklist {
    return value?.objectType === "SimStation.BO.UserRecordingChecklist";
  }
  static isUserRecordingAssessment(value: any): value is UserRecordingAssessment {
    return value?.objectType === "SimStation.BO.UserRecordingAssessment";
  }
  static isPowerDistributionUnit(value: any): value is PowerDistributionUnit {
    return value?.objectType === "SimStation.BO.PowerDistributionUnit";
  }
  static isTrainingRoomGroupView(value: any): value is TrainingRoomGroupView {
    return value?.objectType === "SimStation.BO.Views.TrainingRoomGroupView";
  }
  static isTraceRecord(value: any): value is TraceRecord {
    return value?.objectType === "SimStation.BO.TraceRecord";
  }
  static isSimGroup(value: any): value is SimGroup {
    return value?.objectType === "SimStation.BO.Groups.SimGroup";
  }
  static isOccupiedTrainingRoom(value: any): value is OccupiedTrainingRoom {
    return value?.objectType === "SimStation.BO.OccupiedTrainingRoom";
  }
  static isPeerPracticeStation(value: any): value is PeerPracticeStation {
    return value?.objectType === "SimStation.BO.Session.PeerPractice.PeerPracticeStation";
  }
  static isAutomaticRecordingSession(value: any): value is AutomaticRecordingSession {
    return value?.objectType === "SimStation.BO.Session.AutomaticRecording.AutomaticRecordingSession";
  }
  static isIpDevice(value: any): value is IpDevice {
    return value?.objectType === "SimStation.BO.IpDevice";
  }
  static isUserCalendarFeedAccessToken(value: any): value is UserCalendarFeedAccessToken {
    return value?.objectType === "SimStation.BO.UserCalendarFeedAccessToken";
  }
  static isSchedulerEventLogEntry(value: any): value is SchedulerEventLogEntry {
    return value?.objectType === "SimStation.BO.SchedulerEventLogEntry";
  }
  static isControlPanel(value: any): value is ControlPanel {
    return value?.objectType === "SimStation.BO.UserInterface.ControlPanel";
  }
  static isScenarioGroupView(value: any): value is ScenarioGroupView {
    return value?.objectType === "SimStation.BO.Views.ScenarioGroupView";
  }
  static isAudioVideoDownloadJobInfo(value: any): value is AudioVideoDownloadJobInfo {
    return value?.objectType === "SimStation.BO.Jobs.AudioVideoDownloadJobInfo";
  }
  static isDynamicInputGroupPreset(value: any): value is DynamicInputGroupPreset {
    return value?.objectType === "SimStation.BO.Audio.DynamicInputGroupPreset";
  }
  static isWebCameraView(value: any): value is WebCameraView {
    return value?.objectType === "SimStation.BO.Views.WebCameraView";
  }
  static isOutlookClientConfig(value: any): value is OutlookClientConfig {
    return value?.objectType === "SimStation.WebAdmin.Services.OutlookService.OutlookClientConfig";
  }
  static isAssessment(value: any): value is Assessment {
    return value?.objectType === "SimStation.BO.Assessment";
  }
  static isSwitchCastVideoProcessingJobInfo(value: any): value is SwitchCastVideoProcessingJobInfo {
    return value?.objectType === "SimStation.BO.Jobs.SwitchCastVideoProcessingJobInfo";
  }
  static isAutomaticRecordingFlowState(value: any): value is AutomaticRecordingFlowState {
    return value?.objectType === "SimStation.BO.Session.AutomaticRecording.AutomaticRecordingFlowState";
  }
  static isPeerPracticeSession(value: any): value is PeerPracticeSession {
    return value?.objectType === "SimStation.BO.Session.PeerPractice.PeerPracticeSession";
  }
  static isExamFlowState(value: any): value is ExamFlowState {
    return value?.objectType === "SimStation.BO.Session.Exam.ExamFlowState";
  }
  static isPeerPracticeFlowState(value: any): value is PeerPracticeFlowState {
    return value?.objectType === "SimStation.BO.Session.PeerPractice.PeerPracticeFlowState";
  }
  static isSchedulerView(value: any): value is SchedulerView {
    return value?.objectType === "SimStation.BO.Views.SchedulerView";
  }
  static isTag(value: any): value is Tag {
    return value?.objectType === "SimStation.BO.Tagging.Tag";
  }
  static isOperatorChecklist(value: any): value is OperatorChecklist {
    return value?.objectType === "SimStation.BO.OperatorChecklist";
  }
  static isExamSession(value: any): value is ExamSession {
    return value?.objectType === "SimStation.BO.Session.Exam.ExamSession";
  }
  static isMultiRoomRecordingStation(value: any): value is MultiRoomRecordingStation {
    return value?.objectType === "SimStation.BO.Session.MultiRoomRecording.MultiRoomRecordingStation";
  }
  static isAutomaticRecordingStation(value: any): value is AutomaticRecordingStation {
    return value?.objectType === "SimStation.BO.Session.AutomaticRecording.AutomaticRecordingStation";
  }
  static isWebClientConnection(value: any): value is WebClientConnection {
    return value?.objectType === "SimStation.BO.WebClientConnections.WebClientConnection";
  }
  static isDeleteTemporaryFileJobInfo(value: any): value is DeleteTemporaryFileJobInfo {
    return value?.objectType === "SimStation.BO.Jobs.DeleteTemporaryFileJobInfo";
  }
  static isMultiRoomRecordingFlowState(value: any): value is MultiRoomRecordingFlowState {
    return value?.objectType === "SimStation.BO.Session.MultiRoomRecording.MultiRoomRecordingFlowState";
  }
  static isEventAttachment(value: any): value is EventAttachment {
    return value?.objectType === "SimStation.BO.EventAttachment";
  }
  static isExamStation(value: any): value is ExamStation {
    return value?.objectType === "SimStation.BO.Session.ExamStation";
  }
  static isChecklist(value: any): value is Checklist {
    return value?.objectType === "SimStation.BO.Checklist";
  }
  static isCompetenceCategory(value: any): value is CompetenceCategory {
    return value?.objectType === "SimStation.BO.CompetenceCategory";
  }
  static isNonSimulationSession(value: any): value is NonSimulationSession {
    return value?.objectType === "SimStation.BO.Session.NonSimulation.NonSimulationSession";
  }
  static isAcl(value: any): value is Acl {
    return value?.objectType === "SimStation.BO.Users.Acl";
  }
  static isSwitchCastVideoUploadJobInfo(value: any): value is SwitchCastVideoUploadJobInfo {
    return value?.objectType === "SimStation.BO.Jobs.SwitchCastVideoUploadJobInfo";
  }
  static isMultiRoomRecordingSession(value: any): value is MultiRoomRecordingSession {
    return value?.objectType === "SimStation.BO.Session.MultiRoomRecording.MultiRoomRecordingSession";
  }
  static isExportProcessInfo(value: any): value is ExportProcessInfo {
    return value?.objectType === "SimStation.BO.Export.ExportProcessInfo";
  }
  static isFavorite(value: any): value is Favorite {
    return value?.objectType === "SimStation.BO.Favorite";
  }
  static isDashboardTileMap(value: any): value is DashboardTileMap {
    return value?.objectType === "SimStation.BO.DashboardTileMap";
  }
  static isDisplayAutoLoginCapability(value: any): value is DisplayAutoLoginCapability {
    return value?.objectType === "SimStation.BO.Device.AutoLoginCapabilities.DisplayAutoLoginCapability";
  }
  static isExaminerPcAutoLoginCapability(value: any): value is ExaminerPcAutoLoginCapability {
    return value?.objectType === "SimStation.BO.Device.AutoLoginCapabilities.ExaminerPcAutoLoginCapability";
  }
  static isExamStudentReadyPcAutoLoginCapability(value: any): value is ExamStudentReadyPcAutoLoginCapability {
    return value?.objectType === "SimStation.BO.Device.AutoLoginCapabilities.ExamStudentReadyPcAutoLoginCapability";
  }
  static isNoneAutoLoginCapability(value: any): value is NoneAutoLoginCapability {
    return value?.objectType === "SimStation.BO.Device.AutoLoginCapabilities.NoneAutoLoginCapability";
  }
  static isStandardizedPatientPcAutoLoginCapability(value: any): value is StandardizedPatientPcAutoLoginCapability {
    return value?.objectType === "SimStation.BO.Device.AutoLoginCapabilities.StandardizedPatientPcAutoLoginCapability";
  }
  static isApplicationData(value: any): value is ApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.ApplicationData";
  }
  static isErrorApplicationData(value: any): value is ErrorApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.ErrorApplicationData";
  }
  static isBasePeerPracticeRunApplicationData(value: any): value is BasePeerPracticeRunApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.PeerPractice.BasePeerPracticeRunApplicationData";
  }
  static isPeerPracticeClosingApplicationData(value: any): value is PeerPracticeClosingApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.PeerPractice.PeerPracticeClosingApplicationData";
  }
  static isPeerPracticeConfirmationApplicationData(value: any): value is PeerPracticeConfirmationApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.PeerPractice.PeerPracticeConfirmationApplicationData";
  }
  static isPeerPracticeEncounterApplicationData(value: any): value is PeerPracticeEncounterApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.PeerPractice.PeerPracticeEncounterApplicationData";
  }
  static isPeerPracticeIntermissionApplicationData(value: any): value is PeerPracticeIntermissionApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.PeerPractice.PeerPracticeIntermissionApplicationData";
  }
  static isPeerPracticeUpcomingSessionApplicationData(value: any): value is PeerPracticeUpcomingSessionApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.PeerPractice.PeerPracticeUpcomingSessionApplicationData";
  }
  static isBaseMultiRoomRecordingRunApplicationData(value: any): value is BaseMultiRoomRecordingRunApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.MultiRoomRecording.BaseMultiRoomRecordingRunApplicationData";
  }
  static isMultiRoomRecordingClosingApplicationData(value: any): value is MultiRoomRecordingClosingApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.MultiRoomRecording.MultiRoomRecordingClosingApplicationData";
  }
  static isMultiRoomRecordingEncounterApplicationData(value: any): value is MultiRoomRecordingEncounterApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.MultiRoomRecording.MultiRoomRecordingEncounterApplicationData";
  }
  static isMultiRoomRecordingFinishedApplicationData(value: any): value is MultiRoomRecordingFinishedApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.MultiRoomRecording.MultiRoomRecordingFinishedApplicationData";
  }
  static isMultiRoomRecordingIntermissionApplicationData(value: any): value is MultiRoomRecordingIntermissionApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.MultiRoomRecording.MultiRoomRecordingIntermissionApplicationData";
  }
  static isMultiRoomRecordingUpcomingSessionApplicationData(value: any): value is MultiRoomRecordingUpcomingSessionApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.MultiRoomRecording.MultiRoomRecordingUpcomingSessionApplicationData";
  }
  static isExamApplicationData(value: any): value is ExamApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.ExamApplicationData";
  }
  static isExamClosingApplicationData(value: any): value is ExamClosingApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.ExamClosingApplicationData";
  }
  static isExamIdleApplicationData(value: any): value is ExamIdleApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.ExamIdleApplicationData";
  }
  static isExamRunEncounterApplicationData(value: any): value is ExamRunEncounterApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.Runs.ExamRunEncounterApplicationData";
  }
  static isExamRunPostEncounterApplicationData(value: any): value is ExamRunPostEncounterApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.Runs.ExamRunPostEncounterApplicationData";
  }
  static isExamRunPreEncounterApplicationData(value: any): value is ExamRunPreEncounterApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.Runs.ExamRunPreEncounterApplicationData";
  }
  static isExamRunStudentReadyApplicationData(value: any): value is ExamRunStudentReadyApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.Runs.ExamRunStudentReadyApplicationData";
  }
  static isExamMasterOfCeremonyApplicationData(value: any): value is ExamMasterOfCeremonyApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.MasterOfCeremony.ExamMasterOfCeremonyApplicationData";
  }
  static isExamMasterOfCeremonyRunApplicationData(value: any): value is ExamMasterOfCeremonyRunApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.MasterOfCeremony.ExamMasterOfCeremonyRunApplicationData";
  }
  static isExamMcClosingApplicationData(value: any): value is ExamMcClosingApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.MasterOfCeremony.ExamMcClosingApplicationData";
  }
  static isExamMcConfirmationClosedApplicationData(value: any): value is ExamMcConfirmationClosedApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.MasterOfCeremony.ExamMcConfirmationClosedApplicationData";
  }
  static isExamMcConfirmationRunningApplicationData(value: any): value is ExamMcConfirmationRunningApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.MasterOfCeremony.ExamMcConfirmationRunningApplicationData";
  }
  static isExamMcEncounterApplicationData(value: any): value is ExamMcEncounterApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.MasterOfCeremony.ExamMcEncounterApplicationData";
  }
  static isExamMcIdleApplicationData(value: any): value is ExamMcIdleApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.MasterOfCeremony.ExamMcIdleApplicationData";
  }
  static isExamMcPostEncounterApplicationData(value: any): value is ExamMcPostEncounterApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.MasterOfCeremony.ExamMcPostEncounterApplicationData";
  }
  static isExamMcPreEncounterApplicationData(value: any): value is ExamMcPreEncounterApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.MasterOfCeremony.ExamMcPreEncounterApplicationData";
  }
  static isExamMcStudentReadyApplicationData(value: any): value is ExamMcStudentReadyApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.MasterOfCeremony.ExamMcStudentReadyApplicationData";
  }
  static isExamConfirmationApplicationData(value: any): value is ExamConfirmationApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.Confirmation.ExamConfirmationApplicationData";
  }
  static isExamConfirmationClosedApplicationData(value: any): value is ExamConfirmationClosedApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.Confirmation.ExamConfirmationClosedApplicationData";
  }
  static isExamConfirmationRunningApplicationData(value: any): value is ExamConfirmationRunningApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Exam.Confirmation.ExamConfirmationRunningApplicationData";
  }
  static isRoomStateScreenApplicationData(value: any): value is RoomStateScreenApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Display.RoomStateScreenApplicationData";
  }
  static isUnusedScreenDisplayApplicationData(value: any): value is UnusedScreenDisplayApplicationData {
    return value?.objectType === "SimStation.BO.Device.ApplicationData.Display.UnusedScreenDisplayApplicationData";
  }
  static isSimUserUnrestricted(value: any): value is SimUserUnrestricted {
    return value?.objectType === "SimStation.BO.Users.SimUserUnrestricted";
  }
  static isWebClientAudioChannelConfiguration(value: any): value is WebClientAudioChannelConfiguration {
    return value?.objectType === "SimStation.BO.WebClientAudioChannelConfiguration";
  }
  static isNetworkAudioOutputChannel(value: any): value is NetworkAudioOutputChannel {
    return value?.objectType === "SimStation.BO.Audio.NetworkAudioOutputChannel";
  }
  static isFileSetConversionJobInfo(value: any): value is FileSetConversionJobInfo {
    return value?.objectType === "SimStation.BO.Jobs.FileSetConversionJobInfo";
  }
  static isDataAcl(value: any): value is DataAcl {
    return value?.objectType === "SimStation.BO.Users.DataAcl";
  }
  static isSwitchCastConfiguration(value: any): value is SwitchCastConfiguration {
    return value?.objectType === "SimStation.BO.SwitchCastIntegration.SwitchCastConfiguration";
  }
  static isOpenIdConnectConfig(value: any): value is OpenIdConnectConfig {
    return value?.objectType === "SimStation.BO.OpenIdConnect.OpenIdConnectConfig";
  }
  static isLmsToken(value: any): value is LmsToken {
    return value?.objectType === "SimStation.BO.LmsIntegration.LmsToken";
  }
  static isDefaultCameraResolutions(value: any): value is DefaultCameraResolutions {
    return value?.objectType === "SimStation.BO.CameraDb.DefaultCameraResolutions";
  }
  static isConversionFileMetaInfo(value: any): value is ConversionFileMetaInfo {
    return value?.objectType === "SimStation.BO.Jobs.ConversionFileMetaInfo";
  }
  static isExamStationView(value: any): value is ExamStationView {
    return value?.objectType === "SimStation.BO.Session.ExamStationView";
  }
  static isAutoLoginCapability(value: any): value is AutoLoginCapability {
    return GeneratedTypePredicates.isDisplayAutoLoginCapability(value) || GeneratedTypePredicates.isExaminerPcAutoLoginCapability(value) || GeneratedTypePredicates.isExamStudentReadyPcAutoLoginCapability(value) || GeneratedTypePredicates.isNoneAutoLoginCapability(value) || GeneratedTypePredicates.isStandardizedPatientPcAutoLoginCapability(value);
  }
  static isIApplicationData(value: any): value is IApplicationData {
    return GeneratedTypePredicates.isApplicationData(value) || GeneratedTypePredicates.isErrorApplicationData(value) || GeneratedTypePredicates.isBasePeerPracticeRunApplicationData(value) || GeneratedTypePredicates.isPeerPracticeClosingApplicationData(value) || GeneratedTypePredicates.isPeerPracticeConfirmationApplicationData(value) || GeneratedTypePredicates.isPeerPracticeEncounterApplicationData(value) || GeneratedTypePredicates.isPeerPracticeIntermissionApplicationData(value) || GeneratedTypePredicates.isPeerPracticeUpcomingSessionApplicationData(value) || GeneratedTypePredicates.isBaseMultiRoomRecordingRunApplicationData(value) || GeneratedTypePredicates.isMultiRoomRecordingClosingApplicationData(value) || GeneratedTypePredicates.isMultiRoomRecordingEncounterApplicationData(value) || GeneratedTypePredicates.isMultiRoomRecordingFinishedApplicationData(value) || GeneratedTypePredicates.isMultiRoomRecordingIntermissionApplicationData(value) || GeneratedTypePredicates.isMultiRoomRecordingUpcomingSessionApplicationData(value) || GeneratedTypePredicates.isExamApplicationData(value) || GeneratedTypePredicates.isExamClosingApplicationData(value) || GeneratedTypePredicates.isExamIdleApplicationData(value) || GeneratedTypePredicates.isExamRunEncounterApplicationData(value) || GeneratedTypePredicates.isExamRunPostEncounterApplicationData(value) || GeneratedTypePredicates.isExamRunPreEncounterApplicationData(value) || GeneratedTypePredicates.isExamRunStudentReadyApplicationData(value) || GeneratedTypePredicates.isExamMasterOfCeremonyApplicationData(value) || GeneratedTypePredicates.isExamMasterOfCeremonyRunApplicationData(value) || GeneratedTypePredicates.isExamMcClosingApplicationData(value) || GeneratedTypePredicates.isExamMcConfirmationClosedApplicationData(value) || GeneratedTypePredicates.isExamMcConfirmationRunningApplicationData(value) || GeneratedTypePredicates.isExamMcEncounterApplicationData(value) || GeneratedTypePredicates.isExamMcIdleApplicationData(value) || GeneratedTypePredicates.isExamMcPostEncounterApplicationData(value) || GeneratedTypePredicates.isExamMcPreEncounterApplicationData(value) || GeneratedTypePredicates.isExamMcStudentReadyApplicationData(value) || GeneratedTypePredicates.isExamConfirmationApplicationData(value) || GeneratedTypePredicates.isExamConfirmationClosedApplicationData(value) || GeneratedTypePredicates.isExamConfirmationRunningApplicationData(value) || GeneratedTypePredicates.isRoomStateScreenApplicationData(value) || GeneratedTypePredicates.isUnusedScreenDisplayApplicationData(value);
  }
  static isTrainingSession(value: any): value is TrainingSession {
    return GeneratedTypePredicates.isTeamTrainingSession(value) || GeneratedTypePredicates.isAutomaticRecordingSession(value) || GeneratedTypePredicates.isExamSession(value) || GeneratedTypePredicates.isMultiRoomRecordingSession(value);
  }
  static isSimSession(value: any): value is SimSession {
    return GeneratedTypePredicates.isTeamTrainingSession(value) || GeneratedTypePredicates.isAutomaticRecordingSession(value) || GeneratedTypePredicates.isPeerPracticeSession(value) || GeneratedTypePredicates.isExamSession(value) || GeneratedTypePredicates.isNonSimulationSession(value) || GeneratedTypePredicates.isMultiRoomRecordingSession(value);
  }
  static isAssessable<T extends AssessableItem>(value: any): value is Assessable<T> {
    return GeneratedTypePredicates.isUserRecordingChecklist(value) || GeneratedTypePredicates.isUserRecordingAssessment(value) || GeneratedTypePredicates.isAssessment(value) || GeneratedTypePredicates.isOperatorChecklist(value) || GeneratedTypePredicates.isChecklist(value);
  }
  static isMappingBase(value: any): value is MappingBase {
    return GeneratedTypePredicates.isPlayerMapping(value) || GeneratedTypePredicates.isTabletMapping(value) || GeneratedTypePredicates.isViewingStationMapping(value) || GeneratedTypePredicates.isTrainingRoomPcMapping(value) || GeneratedTypePredicates.isMasterOfCeremonyMapping(value) || GeneratedTypePredicates.isRecorderMapping(value);
  }
  static isDBObject(value: any): value is DBObject {
    return GeneratedTypePredicates.isAudioInputChannel(value) || GeneratedTypePredicates.isPhoneAudioInputChannel(value) || GeneratedTypePredicates.isAudioOutputChannel(value) || GeneratedTypePredicates.isAudioChannelGroup(value) || GeneratedTypePredicates.isNetworkAudioInputChannel(value) || GeneratedTypePredicates.isBlackboxExporter(value) || GeneratedTypePredicates.isCamera(value) || GeneratedTypePredicates.isEnergySchedule(value) || GeneratedTypePredicates.isGrafanaReportConfiguration(value) || GeneratedTypePredicates.isIconset(value) || GeneratedTypePredicates.isIcon(value) || GeneratedTypePredicates.isFileSet(value) || GeneratedTypePredicates.isMarkerset(value) || GeneratedTypePredicates.isMediaset(value) || GeneratedTypePredicates.isMedia(value) || GeneratedTypePredicates.isScenario(value) || GeneratedTypePredicates.isScenarioGroup(value) || GeneratedTypePredicates.isScheduler(value) || GeneratedTypePredicates.isSynchEndpoint(value) || GeneratedTypePredicates.isExstreamer(value) || GeneratedTypePredicates.isPlayerMapping(value) || GeneratedTypePredicates.isTabletMapping(value) || GeneratedTypePredicates.isViewingStationMapping(value) || GeneratedTypePredicates.isTrainingRoomPcMapping(value) || GeneratedTypePredicates.isMasterOfCeremonyMapping(value) || GeneratedTypePredicates.isRecorderMapping(value) || GeneratedTypePredicates.isLdapConfiguration(value) || GeneratedTypePredicates.isLdapRoleMapping(value) || GeneratedTypePredicates.isSetting(value) || GeneratedTypePredicates.isSimRole(value) || GeneratedTypePredicates.isTracker(value) || GeneratedTypePredicates.isTrainingRoom(value) || GeneratedTypePredicates.isTrainingRoomGroup(value) || GeneratedTypePredicates.isVOGSet(value) || GeneratedTypePredicates.isVTPSet(value) || GeneratedTypePredicates.isWebPage(value) || GeneratedTypePredicates.isTeamTrainingSession(value) || GeneratedTypePredicates.isExamFlow(value) || GeneratedTypePredicates.isRatingItemIconSet(value) || GeneratedTypePredicates.isDevice(value) || GeneratedTypePredicates.isDeviceState(value) || GeneratedTypePredicates.isSynchronizationJobInfo(value) || GeneratedTypePredicates.isScenarioRecording(value) || GeneratedTypePredicates.isSimUser(value) || GeneratedTypePredicates.isConnectedWebClient(value) || GeneratedTypePredicates.isEvent(value) || GeneratedTypePredicates.isUserRecordingChecklist(value) || GeneratedTypePredicates.isUserRecordingAssessment(value) || GeneratedTypePredicates.isPowerDistributionUnit(value) || GeneratedTypePredicates.isTrainingRoomGroupView(value) || GeneratedTypePredicates.isTraceRecord(value) || GeneratedTypePredicates.isSimGroup(value) || GeneratedTypePredicates.isOccupiedTrainingRoom(value) || GeneratedTypePredicates.isAutomaticRecordingSession(value) || GeneratedTypePredicates.isIpDevice(value) || GeneratedTypePredicates.isUserCalendarFeedAccessToken(value) || GeneratedTypePredicates.isSchedulerEventLogEntry(value) || GeneratedTypePredicates.isControlPanel(value) || GeneratedTypePredicates.isScenarioGroupView(value) || GeneratedTypePredicates.isAudioVideoDownloadJobInfo(value) || GeneratedTypePredicates.isDynamicInputGroupPreset(value) || GeneratedTypePredicates.isWebCameraView(value) || GeneratedTypePredicates.isOutlookClientConfig(value) || GeneratedTypePredicates.isAssessment(value) || GeneratedTypePredicates.isSwitchCastVideoProcessingJobInfo(value) || GeneratedTypePredicates.isAutomaticRecordingFlowState(value) || GeneratedTypePredicates.isPeerPracticeSession(value) || GeneratedTypePredicates.isExamFlowState(value) || GeneratedTypePredicates.isPeerPracticeFlowState(value) || GeneratedTypePredicates.isSchedulerView(value) || GeneratedTypePredicates.isTag(value) || GeneratedTypePredicates.isOperatorChecklist(value) || GeneratedTypePredicates.isExamSession(value) || GeneratedTypePredicates.isWebClientConnection(value) || GeneratedTypePredicates.isDeleteTemporaryFileJobInfo(value) || GeneratedTypePredicates.isMultiRoomRecordingFlowState(value) || GeneratedTypePredicates.isEventAttachment(value) || GeneratedTypePredicates.isChecklist(value) || GeneratedTypePredicates.isCompetenceCategory(value) || GeneratedTypePredicates.isNonSimulationSession(value) || GeneratedTypePredicates.isAcl(value) || GeneratedTypePredicates.isSwitchCastVideoUploadJobInfo(value) || GeneratedTypePredicates.isMultiRoomRecordingSession(value) || GeneratedTypePredicates.isExportProcessInfo(value) || GeneratedTypePredicates.isFavorite(value) || GeneratedTypePredicates.isDashboardTileMap(value) || GeneratedTypePredicates.isSimUserUnrestricted(value) || GeneratedTypePredicates.isWebClientAudioChannelConfiguration(value) || GeneratedTypePredicates.isNetworkAudioOutputChannel(value) || GeneratedTypePredicates.isFileSetConversionJobInfo(value) || GeneratedTypePredicates.isDataAcl(value) || GeneratedTypePredicates.isSwitchCastConfiguration(value) || GeneratedTypePredicates.isOpenIdConnectConfig(value) || GeneratedTypePredicates.isLmsToken(value) || GeneratedTypePredicates.isDefaultCameraResolutions(value) || GeneratedTypePredicates.isConversionFileMetaInfo(value);
  }
  static isWebAudioClientMapping(value: any): value is WebAudioClientMapping {
    return GeneratedTypePredicates.isPlayerMapping(value) || GeneratedTypePredicates.isTabletMapping(value) || GeneratedTypePredicates.isViewingStationMapping(value) || GeneratedTypePredicates.isMasterOfCeremonyMapping(value) || GeneratedTypePredicates.isRecorderMapping(value);
  }
  static isSessionFlowState<T extends SessionRunState>(value: any): value is SessionFlowState<T> {
    return GeneratedTypePredicates.isAutomaticRecordingFlowState(value) || GeneratedTypePredicates.isExamFlowState(value) || GeneratedTypePredicates.isPeerPracticeFlowState(value) || GeneratedTypePredicates.isMultiRoomRecordingFlowState(value);
  }
  static isAudioChannel(value: any): value is AudioChannel {
    return GeneratedTypePredicates.isAudioInputChannel(value) || GeneratedTypePredicates.isPhoneAudioInputChannel(value) || GeneratedTypePredicates.isAudioOutputChannel(value) || GeneratedTypePredicates.isNetworkAudioInputChannel(value) || GeneratedTypePredicates.isWebClientAudioChannelConfiguration(value) || GeneratedTypePredicates.isNetworkAudioOutputChannel(value);
  }
  static isBaseJobInfo(value: any): value is BaseJobInfo {
    return GeneratedTypePredicates.isSynchronizationJobInfo(value) || GeneratedTypePredicates.isAudioVideoDownloadJobInfo(value) || GeneratedTypePredicates.isSwitchCastVideoProcessingJobInfo(value) || GeneratedTypePredicates.isDeleteTemporaryFileJobInfo(value) || GeneratedTypePredicates.isSwitchCastVideoUploadJobInfo(value) || GeneratedTypePredicates.isExportProcessInfo(value) || GeneratedTypePredicates.isFileSetConversionJobInfo(value);
  }
  static isDBConfig(value: any): value is DBConfig {
    return GeneratedTypePredicates.isLdapConfiguration(value) || GeneratedTypePredicates.isOutlookClientConfig(value) || GeneratedTypePredicates.isAcl(value) || GeneratedTypePredicates.isDataAcl(value) || GeneratedTypePredicates.isSwitchCastConfiguration(value) || GeneratedTypePredicates.isOpenIdConnectConfig(value) || GeneratedTypePredicates.isLmsToken(value) || GeneratedTypePredicates.isDefaultCameraResolutions(value);
  }
  static isBasePeerPracticeApplicationData(value: any): value is BasePeerPracticeApplicationData {
    return GeneratedTypePredicates.isBasePeerPracticeRunApplicationData(value) || GeneratedTypePredicates.isPeerPracticeClosingApplicationData(value) || GeneratedTypePredicates.isPeerPracticeConfirmationApplicationData(value) || GeneratedTypePredicates.isPeerPracticeEncounterApplicationData(value) || GeneratedTypePredicates.isPeerPracticeIntermissionApplicationData(value) || GeneratedTypePredicates.isPeerPracticeUpcomingSessionApplicationData(value);
  }
  static isExamRunApplicationData(value: any): value is ExamRunApplicationData {
    return GeneratedTypePredicates.isExamRunEncounterApplicationData(value) || GeneratedTypePredicates.isExamRunPostEncounterApplicationData(value) || GeneratedTypePredicates.isExamRunPreEncounterApplicationData(value) || GeneratedTypePredicates.isExamRunStudentReadyApplicationData(value);
  }
  static isBaseMultiRoomRecordingApplicationData(value: any): value is BaseMultiRoomRecordingApplicationData {
    return GeneratedTypePredicates.isBaseMultiRoomRecordingRunApplicationData(value) || GeneratedTypePredicates.isMultiRoomRecordingClosingApplicationData(value) || GeneratedTypePredicates.isMultiRoomRecordingEncounterApplicationData(value) || GeneratedTypePredicates.isMultiRoomRecordingFinishedApplicationData(value) || GeneratedTypePredicates.isMultiRoomRecordingIntermissionApplicationData(value) || GeneratedTypePredicates.isMultiRoomRecordingUpcomingSessionApplicationData(value);
  }

}